package org.zq.astrock_ai.quant

import org.zq.astrock_ai.api.dto.QuantBacktestDto
import org.zq.astrock_ai.api.dto.QuantBacktestTradeDto
import org.zq.astrock_ai.api.dto.QuantResultDto

fun QuantPlan.toDto(): QuantResultDto = QuantResultDto(
    strategyId = strategyId,
    strategyName = strategyName,
    signal = signal.side,
    signalReason = signal.reason,
    asOf = signal.asOf,
    price = signal.price,
    planSummary = summary,
    entryHint = entryHint,
    exitHint = exitHint,
    invalidation = invalidation,
    backtest = backtest.toDto(),
    positionNote = positionNote,
    consensus = consensus,
)

fun BacktestResult.toDto(): QuantBacktestDto = QuantBacktestDto(
    lookbackDays = lookbackDays,
    trades = trades,
    winRate = winRate,
    totalReturnPct = totalReturnPct,
    maxDrawdownPct = maxDrawdownPct,
    note = note,
    tradeDetails = tradeDetails.map {
        QuantBacktestTradeDto(
            entryDate = it.entryDate,
            exitDate = it.exitDate,
            entryPrice = it.entryPrice,
            exitPrice = it.exitPrice,
            returnPct = it.returnPct,
        )
    },
    equityCurve = equityCurve,
)

fun QuantBundle.toResultDto(): QuantResultDto? {
    plan?.let { return it.toDto() }
    val s = signal ?: return null
    return QuantResultDto(
        strategyId = s.strategyId,
        strategyName = s.strategyName,
        signal = s.side,
        signalReason = s.reason,
        asOf = s.asOf,
        price = s.price,
        backtest = backtest?.toDto(),
        consensus = consensus,
    )
}

fun positionContextOf(
    costPrice: Double?,
    quantity: Int?,
    currentPrice: Double? = null,
): PositionContext? {
    if (costPrice == null && quantity == null) return null
    val has = costPrice != null && quantity != null && quantity > 0
    return PositionContext(
        hasPosition = has,
        costPrice = costPrice,
        quantity = quantity,
        currentPrice = currentPrice,
    )
}
